import type {
	TimesheetBucketKind,
	TimesheetRow,
	TimesheetTotals,
} from "../types";

export const BUCKET_KINDS: TimesheetBucketKind[] = [
	"weekday",
	"saturday",
	"sunday",
	"holiday",
];

export interface TimesheetRowSums extends TimesheetTotals {
	daysPresent: number;
	daysAbsent: number;
	daysMedicalLeave: number;
	daysDayOff: number;
	daysPending: number;
	normalMinutes: number;
	missingMinutes: number;
	overtimeByKind: Record<TimesheetBucketKind, number>;
	totalEquivalentMinutes: number;
}

export function sumRows(rows: TimesheetRow[]): TimesheetRowSums {
	const sums: TimesheetRowSums = {
		daysPresent: 0,
		daysAbsent: 0,
		daysMedicalLeave: 0,
		daysDayOff: 0,
		daysPending: 0,
		workedMinutes: 0,
		normalMinutes: 0,
		missingMinutes: 0,
		overtimeByKind: { weekday: 0, saturday: 0, sunday: 0, holiday: 0 },
		overtimeMinutes: 0,
		overtimeEquivalentMinutes: 0,
		totalEquivalentMinutes: 0,
	};
	for (const row of rows) {
		sums.daysPresent += row.daysPresent;
		sums.daysAbsent += row.daysAbsent;
		sums.daysMedicalLeave += row.daysMedicalLeave;
		sums.daysDayOff += row.daysDayOff;
		sums.daysPending += row.daysPending;
		sums.workedMinutes += row.workedMinutes;
		sums.normalMinutes += row.normalMinutes;
		sums.missingMinutes += row.missingMinutes;
		for (const kind of BUCKET_KINDS) {
			sums.overtimeByKind[kind] += row.overtime[kind].minutes;
		}
		sums.overtimeMinutes += row.overtimeMinutes;
		sums.overtimeEquivalentMinutes += row.overtimeEquivalentMinutes;
		sums.totalEquivalentMinutes += row.totalEquivalentMinutes;
	}
	return sums;
}

export function pendingDays(rows: TimesheetRow[]): number {
	return rows.reduce((total, row) => total + row.daysPending, 0);
}
